import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch('https://web-portal-backend-production.up.railway.app/api/forms/submit/primecaredental', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          formData: {
            name: formData.name,
            email: formData.email,
            message: formData.message,
            formType: 'contact'
          }
        }),
      });
  
      const responseData = await response.json();
  
      if (response.ok) {
        setIsSubmitting(false);
        setSubmitMessage('Thank you for your message! We will get back to you within 24 hours.');
        setFormData({
          name: '',
          email: '',
          message: ''
        });
        
        // Clear success message after 5 seconds
        setTimeout(() => setSubmitMessage(''), 5000);
      } else {
        // Log the actual server error
        console.error('Server error response:', responseData);
        throw new Error(responseData.message || 'Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setIsSubmitting(false);
      setSubmitMessage(`There was an error submitting your message: ${error.message}. Please try again.`);
      
      // Clear error message after 5 seconds
      setTimeout(() => setSubmitMessage(''), 5000);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
    
  //   try {
  //     const response = await fetch('https://web-portal-backend-production.up.railway.app/api/forms/submit/orhodontic-dent', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         formData: {
  //           name: formData.name,
  //           email: formData.email,
  //           message: formData.message,
  //           formType: 'contact'
  //         }
  //       }),
  //     });

  //     if (response.ok) {
  //       setIsSubmitting(false);
  //       setSubmitMessage('Thank you for your message! We will get back to you within 24 hours.');
  //       setFormData({
  //         name: '',
  //         email: '',
  //         message: ''
  //       });
        
  //       // Clear success message after 5 seconds
  //       setTimeout(() => setSubmitMessage(''), 5000);
  //     } else {
  //       throw new Error('Failed to submit form');
  //     }
  //   } catch (error) {
  //     console.error('Error submitting form:', error);
  //     setIsSubmitting(false);
  //     setSubmitMessage('There was an error submitting your message. Please try again.');
      
  //     // Clear error message after 5 seconds
  //     setTimeout(() => setSubmitMessage(''), 5000);
  //   }
  // };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4M20 8L12 13L4 8V6L12 11L20 6V8Z"/>
            </svg>
            Contact Us
          </div>
          <h2 className="section-title">Get In Touch With Prime Care Dental</h2>
          <p className="section-description">
            Have a question or want to schedule an appointment? Contact Dr. Muhammad Junaid's clinic and we'll get back to you as soon as possible.
          </p>
        </div>

        <div className="contact-content">
          {/* Contact Information */}
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2M12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5Z"/>
                </svg>
              </div>
              <div className="info-content">
                <h4>Visit Our Clinic</h4>
                <p>45 F main market Gulberg 2 Lahore</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"/>
                </svg>
              </div>
              <div className="info-content">
                <h4>Call Us</h4>
                <p>0308 0006494</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4M20 8L12 13L4 8V6L12 11L20 6V8Z"/>
                </svg>
              </div>
              <div className="info-content">
                <h4>Email Us</h4>
                <p>drmjunaid14384@gmail.com</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12.5 7V12.25L17 14.92L16.25 16.15L11 13V7H12.5Z"/>
                </svg>
              </div>
              <div className="info-content">
                <h4>Working Hours</h4>
                <p>Daily: 3:00 PM - 10:00 PM</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-wrapper">
            <div className="form-header">
              <h3>Send Us a Message</h3>
              <p>Fill out the form below and we'll get back to you as soon as possible.</p>
            </div>

            {submitMessage && (
              <div className="success-message">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
                </svg>
                {submitMessage}
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="your.email@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows="5"
                  placeholder="Tell us how we can help you..."
                ></textarea>
              </div>

              <div className="form-actions">
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <div className="spinner"></div>
                      Sending...
                    </>
                  ) : (
                    <>
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z"/>
                      </svg>
                      Send Message
                    </>
                  )}
                </button>
                
                <div className="quick-contact">
                  <span>Need to schedule an appointment?</span>
                  <Link to="/appointment" className="appointment-btn">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V8H19V19M7 10H12V15H7"/>
                    </svg>
                    Book Appointment
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Map Section */}
        <div className="map-section">
          <div className="map-header">
            <h3>Find Us</h3>
          </div>
          <div className="map-placeholder">
            <div className="map-content">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2M12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5Z"/>
              </svg>
              <h4>Prime Care Dental</h4>
              <p>45 F main market Gulberg 2 Lahore</p>
              <a href="https://maps.app.goo.gl/t6Tjyj8TgTvBcFyF9" target="_blank" rel="noopener noreferrer" className="directions-btn">
                Get Directions
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
